"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_LANGUAGE = exports.AVAILABLE_LANGUAGES = exports.Languages = void 0;
var Languages;
(function (Languages) {
    Languages["en"] = "en";
    Languages["de"] = "de";
    Languages["es"] = "es";
    Languages["pt"] = "pt";
    Languages["cs"] = "cs";
    Languages["zh"] = "zh";
    Languages["ko"] = "ko";
    Languages["fr"] = "fr";
    Languages["sv"] = "sv";
    Languages["hi"] = "hi";
})(Languages || (exports.Languages = Languages = {}));
exports.AVAILABLE_LANGUAGES = [
    Languages.en,
    Languages.es,
    Languages.de,
    Languages.fr,
    Languages.zh,
    Languages.sv,
    Languages.ko,
    Languages.pt,
    Languages.hi,
];
exports.DEFAULT_LANGUAGE = Languages.en;
//# sourceMappingURL=Languages.js.map